import * as yup from 'yup';

yup.addMethod(yup.array, 'uniqueIn', function (mapper = (a: unknown) => a, message = '') {
  return this.test('unique', message, function (list: unknown[]) {
    return list?.length === new Set(list?.map(mapper)).size;
  });
});

// biome-ignore lint/style/noDefaultExport: necessary
export default yup;
